/** Parse comma/semicolon/newline-separated emails for trip invites. */
export function parseTripInviteeInput(raw: string): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const part of raw.split(/[,;\n]+/)) {
    const email = part.trim().toLowerCase();
    if (!email || seen.has(email)) continue;
    seen.add(email);
    out.push(email);
  }
  return out;
}

export function formatTripInviteeInput(emails: string[]): string {
  return emails.join(', ');
}

export function tripInviteesForGoogleCalendar(emails: string[]): Array<{ email: string }> | undefined {
  if (emails.length === 0) return undefined;
  return emails.map(email => ({ email }));
}
